/*
  不良登録画面のベースコンポーネント
*/
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import Navbar from "../navbar/Navbar";
import DefectsInfo from "./DefectsInfo";
import DefectsDetail from "./DefectsDetail";
import Footer from "../footer/Footer";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import {
  setNewDefectsDetails,
  postDefects,
  fetchProcs,
  DefectsDetailProp,
} from "../../redux/defectsSlice";
import RippleButton from "../ui/rippleButton";
import "./Defects.css";

const Defects: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const defects = useSelector((state: RootState) => state.defects);
  // ログインユーザーID
  const userId = useSelector(
    (state: RootState) => state.user.userInfo?.user_id ?? ""
  );

  // 自身が同一不良発生回数内で最小のIDをもつレコードか判定する
  const isMinDefectsId = (
    defects: DefectsDetailProp[],
    defect: DefectsDetailProp
  ) => {
    const ids = defects
      .filter((d) => d.failure_count === defect.failure_count)
      .map((d) => d.defect_type_seq);
    const minId = Math.min.apply(null, ids);
    return minId === defect.defect_type_seq ? true : false;
  };

  // 不良詳細の追加処理
  const handleAddDefectsDatail = () => {
    dispatch(setNewDefectsDetails());
  };

  // 登録ボタンの処理
  const handlerRegistDefects = () => {
    dispatch(postDefects(defects, userId));
  };

  // 加工実績の取得
  useEffect(() => {
    console.log("加工実績の取得");
    console.log(defects.procParams);
    dispatch(fetchProcs(defects.procParams));
  }, []);

  return (
    <>
      <Helmet>
        <title>Process Flow Manager</title>
      </Helmet>
      {/* ナビバー */}
      <Navbar />
      <div className="defects-container">
        {/* 不良情報 */}
        <div className="defects-info-item">
          <DefectsInfo />
        </div>
        {/* 区切り線 */}
        {defects.procParams.poDescNum !== "" && (
          <div className="defects-sline-item">
            <div className="sepalate-line"></div>
          </div>
        )}
        {/* 不良情報詳細 */}
        <div className="defects-detail-item">
          {defects.defectsDetails.map((item, index) => (
            <DefectsDetail
              index={index}
              defectsDetail={item}
              minFlag={isMinDefectsId(defects.defectsDetails, item)}
            />
          ))}
        </div>

        {/* 追加登録ボタン */}
        {defects.procParams.poDescNum !== "" && (
          <div className="defects-add-button-item">
            <img
              src="images/defects-add-regist.svg"
              alt="追加ボタン"
              className="defects-icon"
              onClick={handleAddDefectsDatail}
            />
            <p>追加登録</p>
          </div>
        )}

        {/* 登録ボタン */}
        {defects.procParams.poDescNum !== "" &&
          defects.defectsDetails.length > 0 && (
            <div className="defects-reg-button-item">
              <RippleButton
                width={"192px"}
                heihgt={"62px"}
                borderRadius={"8px"}
                onClick={handlerRegistDefects}
                effectSize={160}
                className="bk-secondary"
              >
                <span className="children">登録</span>
              </RippleButton>
            </div>
          )}
      </div>
      {/* フッター */}
      <Footer />
    </>
  );
};

export default Defects;
